import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, Typography, Container, createMuiTheme, MuiThemeProvider } from '@material-ui/core'
import { AddCircle, ExpandMore, RemoveCircle, ToggleOff } from '@material-ui/icons'
import React, { Fragment, useState,useEffect } from 'react'
import firebase from "firebase";

const styleTheme = createMuiTheme({
  overrides: {
    MuiAccordionSummary: {
      root: {
        "& .MuiAccordionSummary-expandIcon.Mui-expanded": {
          color: "#9A4E43",
          transform: "rotate(45deg)"
        }
        }
      }
    }
  }
)

function FAQ(props) {
    const {faqs} = props;

      const Question = (props)=>{
        
        const {question,indx} = props
       
        return <Accordion style={{width:"100%",marginBottom:"10px"}}>
        <AccordionSummary
          
          expandIcon={<AddCircle />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >

        <Typography>Pitanje {indx+1}: {question.value_Q} ? </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Typography>
          {question.value_A}
          </Typography>
        </AccordionDetails>
      </Accordion>
      }

    
    return (
      <MuiThemeProvider theme={styleTheme}>
        <Grid
            container 
            direction="column"  
            justify="space-around"   
            alignContent="center" 
            alignItems="center" 
            
        >
          <Container maxWidth="false" style={{maxWidth: "680px"}}>
            {/* TODO ADD RED LINE AND REMOVE BR */}
            <br></br>            <br></br>
            <Typography variant="h4" style={{color:"#0E1B4D",fontWeight:"bold",textAlign:"center"}}>
                VAŽNE INFORMACIJE
            </Typography>

            <br></br>
            {
               faqs.map((i,indx)=>{
                    return <Question  question = {i} indx={indx}/>
                })
            }
          </Container>
            
        </Grid>
      </MuiThemeProvider>
        
    )
}

export default FAQ
